import React, { Component } from 'react'

import styles from './forbidden.styl'
import Title from '../../../components/misc/Title/Title'
import { Footer, Header, LayoutPlain } from '../../../components/layout'


class Forbidden extends Component {
    static propTypes = {
    }

    static defaultProps = {}

    render() {
        return (

          <LayoutPlain
            header={<Header />}
            footer={<Footer />}
            body={[<div className={styles.wrapper}>
              <Title h2 intlKey="moduleTitle.forbidden">
                Forbidden
              </Title>
              <class className={`${`ico ico--sad`} ${styles.large}`} /> <br />
            </div>]}
            colWidth="320px"
          />


        )
    }
}

export default Forbidden
